import Form from 'components/Form';

import { Fragment } from 'react';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContent';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const DNAAgency = (props: Props) => {
  const { disabled, register } = props;

  const infos = [
    { title: '기관명', value: 'lab_name' },
    { title: '전화번호', value: 'lab_contact' },
  ];

  return (
    <Fragment>
      <SectionTitle title="유전자 검사기관" />
      <RowContainer xs={12} sx={{ margin: '20px 0px 30px 0px' }}>
        {infos.map(({ title, value }) => (
          <RowContent title={title} titleRatio={1.5} childrenRatio={10}>
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              {...register(`${value}`)}
            />
          </RowContent>
        ))}
      </RowContainer>
    </Fragment>
  );
};

export default DNAAgency;
